





























































































































import {Component, Vue} from "vue-property-decorator";
import TaxEventDTO from "@/dto/tax/TaxEventDTO";
import TaxEventFilter, {TaxEventSortField} from "@/dto/tax/TaxEventFilter";
import TaxEventService from "@/services/TaxEventService";
import SimpleProfileSearch from "@/components/common/SimpleProfileSearch.vue";
import DictionarySelect from "@/components/common/DictionarySelect.vue";
import PortalInput from "@/components/common/PortalInput.vue";
import PortalSelect from "@/components/common/PortalSelect.vue";
import SelectOption from "@/components/common/SelectOption";
import PaginationComponent from "@/components/util/PaginationComponent.vue";
import ProfileDTO from "@/dto/profile/ProfileDTO";
import moment from "moment";
import {processError} from "@/utils/ComponentUtils";
import CreateTaxEventModal from "@/components/admin/tax/CreateTaxEventModal.vue";

@Component({
  components: {
    SimpleProfileSearch,
    DictionarySelect,
    PortalInput,
    PortalSelect,
    PaginationComponent,
    CreateTaxEventModal
  }
})
export default class TaxCalendar extends Vue {

  private filter = new TaxEventFilter();
  private taxEvents: TaxEventDTO[] = [];
  private totalPages = 1;

  get isPaidOptions(): SelectOption[] {
    return [
      SelectOption.builder().title("All").value(null).build(),
      SelectOption.builder().title("Paid").value(true).build(),
      SelectOption.builder().title("Unpaid").value(false).build()
    ];
  }

  public mounted(): void {
    this.syncFilterFromQuery();
    this.loadPage();
  }

  private syncFilterFromQuery(): void {
    const q = this.$route.query;
    if (q.dateFrom) this.filter.dateFrom = q.dateFrom as string;
    if (q.dateTo) this.filter.dateTo = q.dateTo as string;
    if (q.isPaid) this.filter.isPaid = q.isPaid === 'true';
    if (q.taxTypeId) this.filter.taxTypeId = Number(q.taxTypeId);
    if (q.customerId) this.filter.customerId = Number(q.customerId);
    if (q.customerType) this.filter.customerType = q.customerType as any;
    if (q.pageNumber) this.filter.pageNumber = Number(q.pageNumber);
    if (q.sortBy) this.filter.sortBy = q.sortBy as any;
    if (q.sortDirection) this.filter.sortDirection = q.sortDirection as any;
  }

  private applyRouteParams(): void {
    const query: any = {};
    if (this.filter.dateFrom) query.dateFrom = this.filter.dateFrom;
    if (this.filter.dateTo) query.dateTo = this.filter.dateTo;
    if (this.filter.isPaid !== null) query.isPaid = String(this.filter.isPaid);
    if (this.filter.taxTypeId) query.taxTypeId = String(this.filter.taxTypeId);
    if (this.filter.customerId) query.customerId = String(this.filter.customerId);
    if (this.filter.customerType) query.customerType = this.filter.customerType;
    if (this.filter.pageNumber > 1) query.pageNumber = String(this.filter.pageNumber);
    if (this.filter.sortBy !== TaxEventSortField.CREATED_AT) query.sortBy = this.filter.sortBy;
    if (this.filter.sortDirection !== "DESC") query.sortDirection = this.filter.sortDirection;

    this.$router.replace({query}).catch(() => this.$void());
  }

  async handleSearch() {
    this.filter.pageNumber = 1;
    await this.loadPage();
  }

  async loadPage() {
    this.$loadOn();
    try {
      const response = await TaxEventService.getTaxEvents(this.filter)
      this.taxEvents = response.data.content;
      this.totalPages = response.data.totalPages;
      this.applyRouteParams();
    } catch (e) {
      processError(e, this)
    } finally {
      this.$loadOff();
    }
  }

  public changePage(page: number): void {
    this.filter.pageNumber = page;
    this.loadPage();
  }

  public clearFilter(): void {
    this.filter = new TaxEventFilter();
  }

  public onCustomerSelected(profile: ProfileDTO | null): void {
    if (profile) {
      this.filter.customerId = profile.id;
      this.filter.customerType = profile.type as any;
    } else {
      this.filter.customerId = null;
      this.filter.customerType = null;
    }
  }

  public switchOrder(field: TaxEventSortField): void {
    if (this.filter.sortBy === field) {
      this.filter.sortDirection = this.filter.sortDirection === 'ASC' ? 'DESC' : 'ASC';
    } else {
      this.filter.sortBy = field;
      this.filter.sortDirection = 'ASC';
    }
    this.loadPage();
  }

  public getSortIcon(field: TaxEventSortField): string {
    if (this.filter.sortBy !== field) {
      return "sort";
    }
    return this.filter.sortDirection === 'ASC' ? "sort-up" : "sort-down";
  }

  public formatAmount(cents: number): string {
    return '$' + (cents / 100).toFixed(2);
  }

  goToEvent(id: number) {
    this.$router.push({ name: 'tax_event', params: { id: id.toString() } });
  }

  public formatDate(iso: string): string {
    if (!iso) return '';
    try {
      return moment(iso).format('MM/DD/YYYY HH:mm');
    } catch {
      return iso;
    }
  }
}
